<template>
  <div :class="[{'fl_list_head_date_blockE':toListDate.length==8},'fl_list_head_date_block']">
    <div v-for="(date_item,date_index) in toListDate" @click="FLSelectDate(date_item,date_index)" :class="[{'fl_list_head_date_itemS':date_index==order_date_index},'fl_list_head_date_item']">
      <div class="fl_list_head_date_item_title1">{{date_item.date_week}}</div>
      <div class="fl_list_head_date_item_title2">{{date_item.date_simple}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      toListDate:Array,
      order_date_index:Number
    },
    data() {
      return {

      }
    },
    created() {},
    mounted() {

    },
    methods:{
      FLSelectDate(item,index){
        var params={
          item:item,
          index:index,
        }
        this.$emit('FLDateChildEvent',params)
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fl_list_head_date_block{
    width: calc(140*@vm_base * 7 + 16*@vm_base);
    .fl_list_head_date_item{
      width: 120*@vm_base;
      height: 120*@vm_base;
      background: #FFFFFF;
      border-radius: 12*@vm_base;
      border: 1*@vm_base solid #DDDDDD;
      float: left;
      margin-right: 20*@vm_base;
      color: #444054;
      .fl_list_head_date_item_title1{
        width: 100%;
        font-size: 32*@vm_base;
        font-weight: 500;
        line-height: 1;
        text-align: center;
        margin-top: 26*@vm_base;
      }
      .fl_list_head_date_item_title2{
        width: 100%;
        margin-top: 12*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 400;
        line-height: 1;
        text-align: center;
      }
    }
    .fl_list_head_date_itemS{
      background: #444054;
      color: #FFFFFF;
    }
  }
  .fl_list_head_date_blockE{
    width: calc(140*@vm_base * 8 + 16*@vm_base);
  }
</style>



// WEBPACK FOOTER //
// src/components/subgroup/appointmentDate.vue